import { APIResult } from './api';

const api = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    deleteFile(context: any, deletekey: string) {
      return context.dispatch('API', { url: `files/${deletekey}`, method: 'delete' });
    },
    getFileInfo(context: any, id: number) {
      return context.dispatch('API', { url: `files/${id}`, method: 'get' }).then((res: APIResult) => {
        return res.data.message;
      });
    },
    uploadFile(context: any, { file, progresshandler, media }: { file: any; progresshandler: any; media: boolean }) {
      const data = new FormData();
      data.append('file', file);

      return context
        .dispatch('API', {
          url: media ? 'medialib' : 'files',
          method: 'put',
          data,
          progresshandler,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res: any) => res.data.message);
    },
  },
};

export default api;
